module.exports = __webpack_public_path__ + "img/logo-dark.ec265a3c.png";